<div class="report-table">
  <app-gc-table-wrapper
    [data]="tableWrapperConfig()"
    (itemsPerPageSelected)="setItemsPerPage($event)"
    (searchInputChanged)="onSearchInputChanged($event)"
    (paginationChanged)="onPaginationChanged($event)"
  >
    <gc-table
      [tableRows]="tableRows()"
      [tableColumns]="
        tableColumns() | translateArray: (language$ | async)! : 'headerText'
      "
      [selectableRows]="selectableRows()"
      [cellTemplates]="{
        macNetAdminId: macNetAdminIdTemplate,
        status: statusTemplate,
        plotDesign: sectionStatusTemplate,
        preinstallation: sectionStatusTemplate,
        plotExcavation: sectionStatusTemplate,
        ductConnection: sectionStatusTemplate,
        cableBlowing: sectionStatusTemplate,
        splicingMeasuring: sectionStatusTemplate,
        commissioning: sectionStatusTemplate,
      }"
      (rowClicked)="onRowClicked($event)"
    ></gc-table>
  </app-gc-table-wrapper>
</div>

<ng-template #sectionStatusTemplate let-section>
  <app-status-table-cell
    [status]="sectionStatusValue(section)"
    [styleMap]="sectionStatusStyles"
    [firstLine]="sectionStatusLabelKey(section) | translate"
    [secondLine]="sectionStatusDate(section)"
  ></app-status-table-cell>
</ng-template>

<ng-template #statusTemplate let-status>
  @if (deliveryStatusTag(status); as tag) {
    <gc-pill [color]="tag.variant">{{ tag.label | translate }}</gc-pill>
  }
</ng-template>

<ng-template #macNetAdminIdTemplate let-object>
  <div class="mac-net-admin-cell">
    @if (object?.macAddress) {
      <app-label-value
        [labelString]="'ordersOverview.deliveryPointsTable.mac' | translate"
        [valueString]="object.macAddress"
      />
    }
    @if (object?.accessId) {
      <app-label-value
        [labelString]="'ordersOverview.deliveryPointsTable.id' | translate"
        [valueString]="object.accessId"
      />
    }
  </div>
</ng-template>
